import { AlertTriangle, XCircle } from 'lucide-react';
import type { DraftIssue } from '../../types/kiosk-flow-types';
import { formatDraftIssue } from '../../utils/flow-steps';

interface FlowValidationSummaryProps {
  issues: DraftIssue[];
}

// Everything to fix in the draft, split by what it blocks — the same issues are marked on the fields
export function FlowValidationSummary({ issues }: FlowValidationSummaryProps) {
  const save = issues.filter((i) => i.blocks === 'save');
  const publish = issues.filter((i) => i.blocks === 'publish');
  if (issues.length === 0) return null;

  return (
    <div className="space-y-2" role="status" aria-label="Flow issues">
      {save.length > 0 && (
        <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700">
          <p className="flex items-center gap-1.5 font-medium">
            <XCircle className="h-4 w-4 shrink-0" />
            Fix before saving
          </p>
          <ul className="mt-1 list-disc space-y-0.5 pl-6">
            {save.map((issue, index) => (
              <li key={index}>{formatDraftIssue(issue)}</li>
            ))}
          </ul>
        </div>
      )}
      {publish.length > 0 && (
        <div className="rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800">
          <p className="flex items-center gap-1.5 font-medium">
            <AlertTriangle className="h-4 w-4 shrink-0" />
            Fix before publishing
          </p>
          <ul className="mt-1 list-disc space-y-0.5 pl-6">
            {publish.map((issue, index) => (
              <li key={index}>{formatDraftIssue(issue)}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
